<template>
  <div
    class="modal fade"
    id="jenkinsJobModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="jenkinsJobModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="jenkinsJobModalLabel">
            <i class="fas fa-cloud-upload-alt mr-2"></i>
            Jobs do Jenkins
            <span v-if="project"> — {{ project.name }}</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div v-if="loading" class="text-center py-4">
            <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
          </div>

          <template v-else>
            <div class="form-group">
              <label>Job do Jenkins (Front)</label>
              <input
                v-model="form.jenkins_job_front"
                class="form-control"
                type="text"
                placeholder="ex: deploy-intranet-front"
              />
            </div>
            <div class="form-group">
              <label>Job do Jenkins (API)</label>
              <input
                v-model="form.jenkins_job_api"
                class="form-control"
                type="text"
                placeholder="ex: deploy-intranet-api"
              />
            </div>

            <hr class="my-2" />
            <small class="text-muted d-block mb-2">
              Homologação (usado quando a release está aguardando testes)
            </small>

            <div class="form-group">
              <label>Job do Jenkins (Front — HML)</label>
              <input
                v-model="form.jenkins_job_front_hml"
                class="form-control"
                type="text"
                placeholder="ex: deploy_sistema_front"
              />
            </div>
            <div class="form-group mb-1">
              <label>Job do Jenkins (API — HML)</label>
              <input
                v-model="form.jenkins_job_api_hml"
                class="form-control"
                type="text"
                placeholder="ex: deploy_sistema_api"
              />
            </div>
            <small class="text-muted">
              Deixe em branco o que não existir. Host, pasta e usuário de SSH
              ficam configurados direto no job, não aqui.
            </small>
          </template>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Cancelar
          </button>
          <a
            class="btn btn-add"
            :class="{ disabled: saving || loading }"
            @click="!saving && !loading && save()"
          >
            {{ saving ? "Salvando..." : "Salvar" }}
            <i class="fa fa-save" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JenkinsJobModal",

  data() {
    return {
      project: null,
      fullProject: null,
      form: {
        jenkins_job_front: "",
        jenkins_job_api: "",
        jenkins_job_front_hml: "",
        jenkins_job_api_hml: "",
      },
      loading: false,
      saving: false,
    };
  },

  methods: {
    open(project) {
      this.project = project;
      this.fullProject = null;
      this.form = {
        jenkins_job_front: "",
        jenkins_job_api: "",
        jenkins_job_front_hml: "",
        jenkins_job_api_hml: "",
      };
      this.loading = true;
      $("#jenkinsJobModal").modal("show");

      const api = this.$store.state.api;

      axios
        .get(api + "projects/" + project.id, {
          params: { with: ["teams", "clients"] },
        })
        .then((response) => {
          const data = response.data.data;
          this.fullProject = Array.isArray(data) ? data[0] : data;
          this.form.jenkins_job_front = this.fullProject.jenkins_job_front || "";
          this.form.jenkins_job_api = this.fullProject.jenkins_job_api || "";
          this.form.jenkins_job_front_hml = this.fullProject.jenkins_job_front_hml || "";
          this.form.jenkins_job_api_hml = this.fullProject.jenkins_job_api_hml || "";
        })
        .catch(() => {
          this.$message("Ops", "Não foi possível carregar o sistema.", "error");
          this.hide();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    save() {
      if (!this.fullProject) return;
      this.saving = true;

      const api = this.$store.state.api + "projects/" + this.fullProject.id;

      const payload = Object.assign({}, this.fullProject);
      payload._method = "PUT";
      payload.jenkins_job_front = this.form.jenkins_job_front;
      payload.jenkins_job_api = this.form.jenkins_job_api;
      payload.jenkins_job_front_hml = this.form.jenkins_job_front_hml;
      payload.jenkins_job_api_hml = this.form.jenkins_job_api_hml;
      payload.teams = (payload.teams || []).map((t) =>
        t && t.id !== undefined ? t.id : t
      );
      payload.clients = (payload.clients || []).map((c) =>
        c && c.id !== undefined ? c.id : c
      );

      axios
        .post(api, payload)
        .then(() => {
          this.$message("Sucesso", "Jobs do Jenkins atualizados.", "success");
          this.hide();
          this.$emit("saved", this.fullProject.id);
        })
        .catch((error) => {
          this.$message(
            "Ops",
            (error.response && error.response.data) ||
              "Não foi possível salvar.",
            "error"
          );
        })
        .finally(() => {
          this.saving = false;
        });
    },

    hide() {
      $("#jenkinsJobModal").modal("hide");
      $("body").removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
  },
};
</script>
